module.exports = __webpack_public_path__ + "media/images/categories/headers/transport-and-travel-e5c0b75161a45adb1e80487ea1a46015.jpg";